// extracted by mini-css-extract-plugin
export var loadingSpinner = "_24-0";
export var spinnerContainer = "_24-1";